import React from 'react'
import { Outlet } from 'react-router-dom'

const JobMvendoronly = () => {
  return (
    <Outlet/>
  )
}

export default JobMvendoronly